// react
import React from 'react';

// internationalization
import { useTranslation } from 'react-i18next';

// material ui
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';

// shared components
import DanishAddressRegisterAutocomplete from '@/components/datafordeler/DanishAddressRegisterAutocomplete';

const EditBuildingDialog = ({
  open,
  onClose,
  building,
  handleEditBuilding,
}) => {
  const { t } = useTranslation();
  const [formState, setFormState] = React.useState({
    Name: building.Name || '',
    AccountId: building.AccountId || 0,
    BaselineDayInterval: building.baselineDayInterval || 10,
    BaselineDayOffset: building.baselineDayOffset || 'PT12H',
    AllowSaturdayBaselineDay: building.allowSaturdayBaselineDay ?? true,
    Location: {
      Address: building.address || '',
      Latitude: building.latitude || null,
      Longitude: building.longitude || null,
    },
    UserInput: building.userInput,
  });

  const handleSubmit = () => {
    if (formState.Name && formState.Location.Address) {
      handleEditBuilding(formState);
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        {t('actions.editItem', {
          item: t('items.building.indefinite', { ns: 'glossary' }),
        })}
      </DialogTitle>
      <DialogContent dividers>
        <TextField
          label="Navn"
          value={formState.Name}
          required
          error={!formState.Name}
          onChange={(e) =>
            setFormState((prev) => ({
              ...prev,
              Name: e.target.value,
            }))
          }
          fullWidth
          variant="filled"
          helperText="Provide a name for the building"
        />
        <DanishAddressRegisterAutocomplete
          onAddressSelect={(selection) => {
            const latitude = Number(selection?.details?.coordinates?.lat);
            const longitude = Number(selection?.details?.coordinates?.lon);
            const address = selection?.parsed?.tekst || '';

            if (
              !address ||
              !Number.isFinite(latitude) ||
              !Number.isFinite(longitude)
            ) {
              return;
            }

            setFormState((prev) => ({
              ...prev,
              Location: {
                Address: address,
                Latitude: latitude,
                Longitude: longitude,
              },
            }));
          }}
          value={formState?.Location?.Address || ''}
          autocompleteProps={{ disabled: false, fullWidth: true }}
          textFieldProps={{ placeholder: 'Vælg adresse', size: 'small' }}
        />
        <Box sx={{ display: 'flex', gap: 2 }}>
          <TextField
            required
            type="number"
            name="BaselineDayInterval"
            label="Baseline Day Interval"
            size="small"
            fullWidth
            variant="filled"
            value={formState.BaselineDayInterval}
            helperText="Interval in days for baseline calculation"
            onChange={(e) =>
              setFormState((prev) => ({
                ...prev,
                BaselineDayInterval: e.target.value,
              }))
            }
          />
          <TextField
            required
            name="BaselineDayOffset"
            label="Baseline Day Offset"
            size="small"
            variant="filled"
            fullWidth
            value={formState.BaselineDayOffset}
            onChange={(e) =>
              setFormState((prev) => ({
                ...prev,
                BaselineDayOffset: e.target.value,
              }))
            }
            helperText="Offset in days for the baseline day calculation"
            // type="number"
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={onClose} color="primary">
          {t('actions.cancel')}
        </Button>
        <Button
          onClick={() => {
            // Handle form submission logic here
            handleSubmit();
            onClose();
          }}
          variant="contained"
        >
          {t('actions.saveChanges')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditBuildingDialog;
